//Cache
let cache = {
    sessionID: '',
    productitle: 'Route Map',
    productid: 33043245793332,
    details: {
      orientation: 'portrait',
      size: '4x6',
      frame: 'noframe',
      layout: 'classicportrait',
      detail: 3,
      mapstyle: 'mapbox://styles/tman16/ckbcuao6e1kdu1ildxzeg3wdw',
      location: [0,52],
      locationfull: {
        town: null,
        county: 'London',
        country: 'United Kingdom'
      },
      mapzoom: 0,
      mapbounds: [],
      text: [
            {
                family: 'Futura',
                color: '#000000',
                size: 12,
                weight: 600,
                value: 'London'
            },
            {
                family: 'Futura Light',
                color: '#000000',
                size: 10,
                weight: 400,
                value: 'United Kingdom'
            },
            {
                family: 'Futura Light',
                color: '#000000',
                size: 10,
                weight: 400,
                value: '12th September 2022'
            }
        ],
      markers: [],
      strava: {},
      loadedroutes: [],
      routes: []
    }
};

//Declare options for right menu
let designobj = {
    options: [
        {
            name: 'Size',
            icon: svgsize,
            description: 'Choose from our selection of print sizes. Changing the orientation alters the layout, you can adjust this in the layout tab.',
            variants: [
                {
                    name: 'Size',
                    id: 'size',
                    type: 'select',
                    variations: [
                        {
                            name: 'Orientation',
                            id: 'orientation',
                            options: [
                                {
                                    name: 'Square',
                                    value: 'square'
                                },
                                {
                                    name: 'Portrait',
                                    value: 'portrait'
                                },
                                {
                                    name: 'Landscape',
                                    value: 'landscape'
                                },
                            ]
                        },
                        {
                            name: 'Size',
                            id: 'size',
                            options: [
                                {
                                    name: '6" x 6"',
                                    value: '6x6',
                                    linked: 'square'
                                },
                                {
                                    name: '8" x 8"',
                                    value: '8x8',
                                    linked: 'square'
                                },
                                {
                                    name: '12" x 12"',
                                    value: '12x12',
                                    linked: 'square'
                                },
                                {
                                    name: '16" x 16"',
                                    value: '16x16',
                                    linked: 'square'
                                },
                                {
                                    name: '20" x 20"',
                                    value: '20x20',
                                    linked: 'square'
                                },
                                {
                                    name: '24" x 24"',
                                    value: '24x24',
                                    linked: 'square'
                                },
                                //Portrait
                                {
                                    name: '4" x 6"',
                                    value: '4x6',
                                    linked: 'portrait'
                                },
                                {
                                    name: '5" x 7"',
                                    value: '5x7',
                                    linked: 'portrait'
                                },
                                {
                                    name: '8" x 10"',
                                    value: '8x10',
                                    linked: 'portrait'
                                },
                                {
                                    name: '9" x 12"',
                                    value: '9x12',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '10" x 15"',
                                    value: '10x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 15"',
                                    value: '12x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 16"',
                                    value: '12x16',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '16" x 20"',
                                    value: '16x20',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '18" x 24"',
                                    value: '18x24',
                                    linked: 'portrait'
                                },
                                {
                                    name: '20" x 30"',
                                    value: '20x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 30"',
                                    value: '24x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 36"',
                                    value: '24x36',
                                    linked: 'portrait'
                                },
                                //Landscape
                                {
                                    name: '6" x 4"',
                                    value: '6x4',
                                    linked: 'landscape'
                                },
                                {
                                    name: '7" x 5"',
                                    value: '7x5',
                                    linked: 'landscape'
                                },
                                {
                                    name: '10" x 8"',
                                    value: '10x8',
                                    linked: 'landscape'
                                },
                                {
                                    name: '12" x 9"',
                                    value: '12x9',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 10"',
                                    value: '15x10',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 12"',
                                    value: '15x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: '16" x 12"',
                                    value: '16x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '20" x 16"',
                                    value: '20x16',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '24" x 18"',
                                    value: '24x18',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 20"',
                                    value: '30x20',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 24"',
                                    value: '30x24',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '36" x 24"',
                                    value: '36x24',
                                    linked: 'landscape'
                                },
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: 'Framing',
            icon: svgframe,
            description: 'Choose from our selection of frame finishes.',
            variants: [
                {
                    name: 'Frame',
                    id: 'frame',
                    type: 'select',
                    variations: [
                        {
                            name: 'Frame',
                            id: 'frame',
                            options: [
                                {
                                    name: 'No Frame',
                                    value: 'noframe'
                                },
                                {
                                    name: 'Matt Black',
                                    value: 'mattblack'
                                },
                                {
                                    name: 'Matt Silver',
                                    value: 'mattsilver'
                                },
                                {
                                    name: 'Brushed Copper',
                                    value: 'brushedcopper'
                                },
                                {
                                    name: 'Brushed Champagne Gold',
                                    value: 'brushedchampagnegold'
                                },
                                {
                                    name: 'Brushed Steel',
                                    value: 'brushedsteel'
                                },
                                {
                                    name: 'Polished Silver',
                                    value: 'polishedsilver'
                                },
                                {
                                    name: 'Polished Dark Grey',
                                    value: 'darkpolishedgrey'
                                },
                                {
                                    name: 'Black Oak',
                                    value: 'blackoak'
                                },
                                {
                                    name: 'White Oak',
                                    value: 'whiteoak'
                                },
                                {
                                    name: 'Oak',
                                    value: 'oak'
                                },
                                {
                                    name: 'Wenge',
                                    value: 'wenge'
                                },
                            ]
                        },
                    ]
                }
            ]
        },
        {
            name: 'Route',
            icon: svglocationmarker,
            description: 'Choose a location/date.',
            variants: [
              {
                name: 'Routes',
                id: 'routes',
                type: 'maproutes',
                variations: []
              }
            ]
        },
        {
            name: 'Style/Text',
            icon: svgpalette,
            description: 'Customise the design of the star map such as the background colour or elements displayed on the star map.',
            variants: [
                {
                    name: 'Text Options',
                    id: 'text',
                    type: 'text',
                    variations: [
                        {
                            name: 'Line 1',
                            id: 'text1',
                            fontstyle: {
                              fonts: [
                                {
                                  name: "Futura",
                                  weights: [400,600]
                                },
                                {
                                  name: "Futura Light",
                                  weights: [400,600]
                                }
                              ],
                              colours: [
                                { name: 'Yellow', value: '#efb702' },
                                { name: 'Orange', value: '#dd7742' },
                                { name: 'Red', value: '#d33b3e' },
                                { name: 'Burgundy', value: '#7f1e17' },
                                { name: 'Fuschia', value: '#d95c80' },
                                { name: 'Blush', value: '#e28a84' },
                                { name: 'Pink', value: '#e79dae' },
                                { name: 'Purple', value: '#6b3687' },
                                { name: 'Eggplant', value: '#421d4a' },
                                { name: 'Pigeon', value: '#9eb3ca' },
                                { name: 'Sky Blue', value: '#9ab5d3' },
                                { name: 'Aqua', value: '#9cd0d3' },
                                { name: 'Turquoise', value: '#52aab3' },
                                { name: 'Royal', value: '#294a94' },
                                { name: 'Blue Jack', value: '#153a51' },
                                { name: 'Midnight', value: '#1a1d29' },
                                { name: 'Grey Blue', value: '#3b4555' },
                                { name: 'Aquamarine', value: '#234955' },
                                { name: 'Cobalt Blue', value: '#141646' },
                                { name: 'Mint', value: '#a5cfae' },
                                { name: 'Forest', value: '#437144' },
                                { name: 'Green Bottle', value: '#214231' },
                                { name: 'Khaki', value: '#616451' },
                                { name: 'Cream', value: '#f4e5ce' },
                                { name: 'Old Paper', value: '#d6bfa0' },
                                { name: 'Clay', value: '#b8a998' },
                                { name: 'Brown', value: '#523527' },
                                { name: 'Duty Blue', value: '#556473' },
                                { name: 'Grey', value: '#a4a4a4' },
                                { name: 'Anthracite', value: '#3b3b3c' },
                                { name: 'Black', value: '#000000' },
                                { name: 'White', value: '#FFFFFF' },
                            ]
                            }
                        },
                        {
                            name: 'Line 2',
                            id: 'text2',
                            fontstyle: {
                              fonts: [
                                {
                                  name: "Futura",
                                  weights: [400,600]
                                },
                                {
                                  name: "Futura Light",
                                  weights: [400,600]
                                }
                              ],
                              colours: [
                                { name: 'Yellow', value: '#efb702' },
                                { name: 'Orange', value: '#dd7742' },
                                { name: 'Red', value: '#d33b3e' },
                                { name: 'Burgundy', value: '#7f1e17' },
                                { name: 'Fuschia', value: '#d95c80' },
                                { name: 'Blush', value: '#e28a84' },
                                { name: 'Pink', value: '#e79dae' },
                                { name: 'Purple', value: '#6b3687' },
                                { name: 'Eggplant', value: '#421d4a' },
                                { name: 'Pigeon', value: '#9eb3ca' },
                                { name: 'Sky Blue', value: '#9ab5d3' },
                                { name: 'Aqua', value: '#9cd0d3' },
                                { name: 'Turquoise', value: '#52aab3' },
                                { name: 'Royal', value: '#294a94' },
                                { name: 'Blue Jack', value: '#153a51' },
                                { name: 'Midnight', value: '#1a1d29' },
                                { name: 'Grey Blue', value: '#3b4555' },
                                { name: 'Aquamarine', value: '#234955' },
                                { name: 'Cobalt Blue', value: '#141646' },
                                { name: 'Mint', value: '#a5cfae' },
                                { name: 'Forest', value: '#437144' },
                                { name: 'Green Bottle', value: '#214231' },
                                { name: 'Khaki', value: '#616451' },
                                { name: 'Cream', value: '#f4e5ce' },
                                { name: 'Old Paper', value: '#d6bfa0' },
                                { name: 'Clay', value: '#b8a998' },
                                { name: 'Brown', value: '#523527' },
                                { name: 'Duty Blue', value: '#556473' },
                                { name: 'Grey', value: '#a4a4a4' },
                                { name: 'Anthracite', value: '#3b3b3c' },
                                { name: 'Black', value: '#000000' },
                                { name: 'White', value: '#FFFFFF' },
                            ]
                            }
                        },
                        {
                            name: 'Line 3',
                            id: 'text3',
                            fontstyle: {
                              fonts: [
                                {
                                  name: "Futura",
                                  weights: [400,600]
                                },
                                {
                                  name: "Futura Light",
                                  weights: [400,600]
                                }
                              ],
                              colours: [
                                { name: 'Yellow', value: '#efb702' },
                                { name: 'Orange', value: '#dd7742' },
                                { name: 'Red', value: '#d33b3e' },
                                { name: 'Burgundy', value: '#7f1e17' },
                                { name: 'Fuschia', value: '#d95c80' },
                                { name: 'Blush', value: '#e28a84' },
                                { name: 'Pink', value: '#e79dae' },
                                { name: 'Purple', value: '#6b3687' },
                                { name: 'Eggplant', value: '#421d4a' },
                                { name: 'Pigeon', value: '#9eb3ca' },
                                { name: 'Sky Blue', value: '#9ab5d3' },
                                { name: 'Aqua', value: '#9cd0d3' },
                                { name: 'Turquoise', value: '#52aab3' },
                                { name: 'Royal', value: '#294a94' },
                                { name: 'Blue Jack', value: '#153a51' },
                                { name: 'Midnight', value: '#1a1d29' },
                                { name: 'Grey Blue', value: '#3b4555' },
                                { name: 'Aquamarine', value: '#234955' },
                                { name: 'Cobalt Blue', value: '#141646' },
                                { name: 'Mint', value: '#a5cfae' },
                                { name: 'Forest', value: '#437144' },
                                { name: 'Green Bottle', value: '#214231' },
                                { name: 'Khaki', value: '#616451' },
                                { name: 'Cream', value: '#f4e5ce' },
                                { name: 'Old Paper', value: '#d6bfa0' },
                                { name: 'Clay', value: '#b8a998' },
                                { name: 'Brown', value: '#523527' },
                                { name: 'Duty Blue', value: '#556473' },
                                { name: 'Grey', value: '#a4a4a4' },
                                { name: 'Anthracite', value: '#3b3b3c' },
                                { name: 'Black', value: '#000000' },
                                { name: 'White', value: '#FFFFFF' },
                            ]
                            }
                        }
                    ]
                },
                {
                    name: 'Map Detail',
                    id: 'detail',
                    desc: 'Adjust detail of map',
                    type: 'fixednumberstepper',
                    step: 1,
                    min: 0,
                    max: 6,
                  moreinfo: {
                    name: 'What is adjust detail?',
                    image: `https://ucarecdn.com/74971683-03be-4f73-8c10-b4949d1c31ba/mapdetailanimate.gif`,
                    html: `Use the + and - buttons to change how detailed the map area will display as, higher detail means more features/text labels will show at the same level of zoom.`
                  }
                },
              {
                name: 'Map Style',
                id: 'mapstyle',
                type: 'colourchips',
                variations: [
                  {
                    name: 'Map Style',
                    id: 'mapstyle',
                    options: [
                      { name: 'Classic B/W', url: 'mapbox://styles/tman16/ck36i7f0s5ra71cm7biergcnw', image: "https://ucarecdn.com/e24df950-7205-43ab-b492-56aa2d3da2d7/Black.jpg" },
                      { name: 'Classic W/B', url: "mapbox://styles/tman16/cjz88vqz12k6t1cr6smf1otoy", image: "https://ucarecdn.com/0eb5a9b3-5a28-4e3e-8e7b-89a5d40104e8/White.jpg" },
                      { name: 'Classic Red', url: "mapbox://styles/tman16/ck37otgw76tyx1cm7hn8jsni4", image: "https://ucarecdn.com/f22064aa-21e9-4842-b8c9-b5aec1d83003/Red.jpg" },
                      { name: 'Classic Blue', url: "mapbox://styles/tman16/ck3w3mgeb3o151cltw4f702w0", image: "https://ucarecdn.com/ac812cba-96f0-44f4-8b50-385fc19023b7/Blue.jpg" },
                      { name: 'Classic Green', url: "mapbox://styles/tman16/ck4o2jx9h0jsv1cruiii969fi", image: "https://ucarecdn.com/10095709-cc80-4334-b193-1b6aa8d6407b/Green.jpg" },
                      { name: 'Classic Grey', url: "mapbox://styles/tman16/ck4o3vfwa6rmh1cur5jq4yhub", image: "https://ucarecdn.com/d088f6b2-1f0a-43bb-93c1-2d730b4df215/Grey.jpg" },
                      { name: 'Classic Orange', url: "mapbox://styles/tman16/ck4o3zbyo4vfk1cms67942ptk", image: "https://ucarecdn.com/4d75a524-7d13-46c3-8d93-2dc7578ed82b/Orange.jpg" },
                      { name: 'Nautical', url: "mapbox://styles/tman16/ck4ou2xv709wn1co6zi232ku4", image: "https://ucarecdn.com/9d248a39-91c7-4a43-b0f5-3a6058c0fc39/Nautical.jpg" },
                      { name: 'Urban', url: "mapbox://styles/tman16/ck5yk0u4j01zo1io0pche8ioa", image: "https://ucarecdn.com/562ad0ba-705b-4939-bfe7-c6083a964f93/Urban.jpg" },
                      { name: 'Streets', url: "mapbox://styles/tman16/ck3y8f50p1sos1cpnheob2xkw", image: "https://ucarecdn.com/1f08f7c7-37a8-4324-ba9b-aaf8cc2ead49/Streets.jpg" },
                      { name: 'Satellite', url: "mapbox://styles/tman16/ck0i0d0fa0a7h1dmdgop0zgr1", image: "https://ucarecdn.com/4bf1d56c-a9a4-4730-b805-cc2575d738fa/Satellite.jpg" },
                      { name: 'Pop', url: "mapbox://styles/tman16/ck5n7ihw15fbk1io9ay9zghb5", image: "https://ucarecdn.com/459a5852-5b1c-4f53-89bc-8a98bf3c203a/Pop.jpg" },
                      { name: 'Maritime', url: 'mapbox://styles/tman16/ck5spo97o3e7u1in3r5f0om68', image: "https://ucarecdn.com/b3156fa9-84a0-40a1-ba87-08bcf14b8db7/Maritime.jpg" },
                      { name: 'Mondrian', url: "mapbox://styles/tman16/ck5uaabwt01401ilorq94bgjy", image: "https://ucarecdn.com/7a9cf423-5365-4c71-83d1-697d02df3426/Mondrian.jpg" },
                      { name: 'Outdoors', url: "mapbox://styles/tman16/ck7g4djj1025w1io4djfvus0o", image: "https://ucarecdn.com/a96fb794-1d61-4593-bc3a-da2a73ae56e6/Outdoors.jpg" },
                      { name: 'Pastel', url: "mapbox://styles/tman16/ckmzpsx1b0djz17p0axe30hn7", image: "https://cdn.shopify.com/s/files/1/0272/8512/7220/files/Pastel.png?v=1617393196" },
                      { name: 'Tricolore', url: "mapbox://styles/tman16/ckbcuao6e1kdu1ildxzeg3wdw", image: "https://cdn.shopify.com/s/files/1/0272/8512/7220/files/Tricolore.jpg?v=1621200524" },
                    ]
                  }
                ]
              },
            ]
        },
        {
            name: 'Layout',
            icon: svglayout,
            description: 'Select a design layout from the options below, these change depending on orientation of the print.',
            variants: [
                {},//blank update designobj search 'val' without using fixed index 1
                {
                    name: 'Layout',
                    id: 'layout',
                    type: 'radio',
                    variations: [
                        //square
                        {
                            name: 'Modern',
                            value: 'modernsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <use xlink:href="#_Image1" x="19.238" y="59.128" width="61.707px" height="34.312px" transform="matrix(0.995271,0,0,0.98035,0,0)"/> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,37.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,40.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,43.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <defs> <image id="_Image1" width="62px" height="35px" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAjCAYAAADMibkBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWUlEQVRoge3TwQnAMAwEQQUCdv8NJ2XoMTsVePHpmZlvQO85Z/sNKwrXvPfe7TescH+8cEw3rnHDmzqmcE03rnHDmzrGDW/qmMI13bimcE03rnHDmzqGDf8BaHQEbhvmzbcAAAAASUVORK5CYII="/> </defs> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Classic',
                            value: 'classicsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,53.8766)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,51.3019)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3295)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Circular',
                            value: 'circularsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,45.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,48.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,51.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,-1.64129)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Borderless No Text',
                            value: 'borderlesssquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Border No text',
                            value: 'bordersquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.969844,-1.35398,1.63528)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Overlay',
                            value: 'overlaysquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        //portrait
                        {
                            name: 'Modern',
                            value: 'modernportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <use xlink:href="#_Image1" x="19.238" y="59.128" width="61.707px" height="34.312px" transform="matrix(0.995271,0,0,0.98035,0,0)"/> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,37.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,40.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,43.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <defs> <image id="_Image1" width="62px" height="35px" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAjCAYAAADMibkBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWUlEQVRoge3TwQnAMAwEQQUCdv8NJ2XoMTsVePHpmZlvQO85Z/sNKwrXvPfe7TescH+8cEw3rnHDmzqmcE03rnHDmzrGDW/qmMI13bimcE03rnHDmzqGDf8BaHQEbhvmzbcAAAAASUVORK5CYII="/> </defs> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Classic',
                            value: 'classicportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,53.8766)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,51.3019)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3295)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Circular',
                            value: 'circularportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,45.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,48.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,51.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,-1.64129)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Borderless No Text',
                            value: 'borderlessportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Border No text',
                            value: 'borderportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.969844,-1.35398,1.63528)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Overlay',
                            value: 'overlayportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        //Landscape
                        {
                            name: 'Modern',
                            value: 'modernlandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <use xlink:href="#_Image1" x="19.238" y="59.128" width="61.707px" height="34.312px" transform="matrix(0.995271,0,0,0.98035,0,0)"/> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,37.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,40.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,43.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <defs> <image id="_Image1" width="62px" height="35px" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAjCAYAAADMibkBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWUlEQVRoge3TwQnAMAwEQQUCdv8NJ2XoMTsVePHpmZlvQO85Z/sNKwrXvPfe7TescH+8cEw3rnHDmzqmcE03rnHDmzrGDW/qmMI13bimcE03rnHDmzqGDf8BaHQEbhvmzbcAAAAASUVORK5CYII="/> </defs> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Classic',
                            value: 'classiclandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,53.8766)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,51.3019)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3295)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Circular',
                            value: 'circularlandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,45.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,48.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,51.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,-1.64129)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Borderless No Text',
                            value: 'borderlesslandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Border No text',
                            value: 'borderlandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.969844,-1.35398,1.63528)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Overlay',
                            value: 'overlaylandscape',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                    ]
                }
            ]
        },
    ]
};

//Design Templates
let layouttemplates = [
    //Square
    {
        name: 'Classic',
        id: 'classicsquare',
        value: 'classicsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,53.8766)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,51.3019)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3295)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '92.5%',
                y: '90%',
                textanchor: 'end',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: `text-transform: uppercase;`
              },
              {
                x: '92.5%',
                y: '92%',
                textanchor: 'end',
                fontsize: '0.12em',
                fontfamily: 'Futura Light'
              },
              {
                x: '92.5%',
                y: '94%',
                textanchor: 'end',
                fontsize: '0.12em',
                fontfamily: 'Futura Light'
              },
            ],
            /*intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <rect width="85%" height="78%" x="7.5%" y="7.5%"></rect>
              </mask>
            `,*/
            overlay: `
              <g id="mask" data-height="78">
                <rect x="0" y="0" width="100%" height="7.5%" fill="#FFFFFF"></rect>
                <rect x="0" y="80%" width="100%" height="20%" fill="#FFFFFF"></rect>
                <rect x="0" y="0" width="7.5%" height="100%" fill="#FFFFFF"></rect>
                <rect x="92.5%" y="0" width="7.5%" height="100%" fill="#FFFFFF"></rect>
              </g>
            `
          }
        },
    },
    {
        name: 'Modern',
        id: 'modernsquare',
        value: 'modernsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <use xlink:href="#_Image1" x="19.238" y="59.128" width="61.707px" height="34.312px" transform="matrix(0.995271,0,0,0.98035,0,0)"/> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,37.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,40.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,43.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <defs> <image id="_Image1" width="62px" height="35px" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAjCAYAAADMibkBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWUlEQVRoge3TwQnAMAwEQQUCdv8NJ2XoMTsVePHpmZlvQO85Z/sNKwrXvPfe7TescH+8cEw3rnHDmzqmcE03rnHDmzrGDW/qmMI13bimcE03rnHDmzqGDf8BaHQEbhvmzbcAAAAASUVORK5CYII="/> </defs> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '50%',
                y: '82%',
                textanchor: 'middle',
                fontsize: '0.36em',
                fontfamily: 'Futura',
                extrastyle: `text-transform: uppercase;`
              },
              {
                x: '50%',
                y: '86%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light'
              },
              {
                x: '50%',
                y: '90%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light'
              },
            ],
            intro: `
              <defs>
                <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="82%">
                  <stop offset="50%" style="stop-color:rgb(255, 255, 255);stop-opacity:0"></stop>
                  <stop offset="100%" style="stop-color:rgb(255, 255, 255);stop-opacity:1"></stop>
                </linearGradient>
              </defs>
            `,
            overlay: `<rect width="100%" height="100%" fill="url(#grad2)"></rect>`
          }
        },
    },
    {
        name: 'Circular',
        id: 'circularsquare',
        value: 'circularsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,45.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,48.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,51.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,-1.64129)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '50%',
                y: '83.5%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: `alignment-baseline: after-edge; text-transform: uppercase;`
              },
              {
                x: '50%',
                y: '87%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light',
                extrastyle: `alignment-baseline: after-edge;`
              },
              {
                x: '50%',
                y: '90%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light',
                extrastyle: `alignment-baseline: after-edge;`
              },
            ],
            intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <circle cx="50%" cy="40%" r="30%"/>
              </mask>
            `,
            overlay: `<rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" mask="url(#myMask)"></rect>`
          }
        },
    },
    {
        name: 'Borderless No Text',
        id: 'borderlesssquare',
        value: 'borderlesssquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '50%',
                y: '80%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
              {
                x: '50%',
                y: '83%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
              {
                x: '50%',
                y: '86%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
            ]
          }
        },
    },
    {
        name: 'Border No Text',
        id: 'bordersquare',
        value: 'bordersquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.969844,-1.35398,1.63528)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '92.5%',
                y: '90%',
                textanchor: 'end',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: `display: none;`
              },
              {
                x: '92.5%',
                y: '92%',
                textanchor: 'end',
                fontsize: '0.12em',
                fontfamily: 'Futura Light',
                extrastyle: `display: none;`
              },
              {
                x: '92.5%',
                y: '94%',
                textanchor: 'end',
                fontsize: '0.12em',
                fontfamily: 'Futura Light',
                extrastyle: `display: none;`
              },
            ],
            intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <rect width="85%" height="85%" x="7.5%" y="7.5%"></rect>
              </mask>
            `,
            overlay: `<rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" mask="url(#myMask)"></rect>`
          }
        },
    },
    {
        name: 'Overlay',
        id: 'overlaysquare',
        value: 'overlaysquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {//viewBox="${svgViewBox}"
          text: {
            pos: [
              {
                x: '50%',
                y: '25%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
              {
                x: '50%',
                y: '50%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
              {
                x: '50%',
                y: '75%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
            ],
          }
        },
    },
    //Portrait
    {
        name: 'Classic',
        id: 'classicportrait',
        value: 'classicportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,53.8766)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,51.3019)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3295)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '92.5%',
                y: '90%',
                textanchor: 'end',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: `text-transform: uppercase;`
              },
              {
                x: '92.5%',
                y: '92%',
                textanchor: 'end',
                fontsize: '0.12em',
                fontfamily: 'Futura Light'
              },
              {
                x: '92.5%',
                y: '94%',
                textanchor: 'end',
                fontsize: '0.12em',
                fontfamily: 'Futura Light'
              },
            ],
            intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <rect width="85%" height="80%" x="7.5%" y="7.5%"></rect>
              </mask>
            `,
            overlay: /*`
            <g id="mask" data-height="80">
            <rect x="0" y="0" width="100%" height="7.5%" fill="#FFFFFF"></rect>
            <rect x="0" y="80%" width="100%" height="20%" fill="#FFFFFF"></rect>
            <rect x="0" y="0" width="7.5%" height="100%" fill="#FFFFFF"></rect>
            <rect x="92.5%" y="0" width="7.5%" height="100%" fill="#FFFFFF"></rect>
            </g>
            `*/`<rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" mask="url(#myMask)"></rect>`
          }
        },
    },
    {
        name: 'Modern',
        id: 'modernportrait',
        value: 'modernportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <use xlink:href="#_Image1" x="19.238" y="59.128" width="61.707px" height="34.312px" transform="matrix(0.995271,0,0,0.98035,0,0)"/> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,37.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,40.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,43.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <defs> <image id="_Image1" width="62px" height="35px" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAjCAYAAADMibkBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWUlEQVRoge3TwQnAMAwEQQUCdv8NJ2XoMTsVePHpmZlvQO85Z/sNKwrXvPfe7TescH+8cEw3rnHDmzqmcE03rnHDmzrGDW/qmMI13bimcE03rnHDmzqGDf8BaHQEbhvmzbcAAAAASUVORK5CYII="/> </defs> </svg>`,
        layout: {//viewBox="${svgViewBox}"
          text: {
            pos: [
              {
                x: '50%',
                y: '82%',
                textanchor: 'middle',
                fontsize: '0.36em',
                fontfamily: 'Futura',
                extrastyle: `text-transform: uppercase;`
              },
              {
                x: '50%',
                y: '86%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light'
              },
              {
                x: '50%',
                y: '90%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light'
              },
            ],
            intro: `
              <defs>
                <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="82%">
                  <stop offset="50%" style="stop-color:rgb(255, 255, 255);stop-opacity:0"></stop>
                  <stop offset="100%" style="stop-color:rgb(255, 255, 255);stop-opacity:1"></stop>
                </linearGradient>
              </defs>
            `,
            overlay: `<rect width="100%" height="100%" fill="url(#grad2)"></rect>`
          }
        },
    },
    {
        name: 'Circular',
        id: 'circularportrait',
        value: 'circularportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,45.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,48.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,51.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,-1.64129)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '50%',
                y: '83.5%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: `alignment-baseline: after-edge; text-transform: uppercase;`
              },
              {
                x: '50%',
                y: '87%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light',
                extrastyle: `alignment-baseline: after-edge;`
              },
              {
                x: '50%',
                y: '90%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light',
                extrastyle: `alignment-baseline: after-edge;`
              },
            ],
            intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <circle cx="50%" cy="40%" r="30%"/>
              </mask>
            `,
            overlay: `<rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" mask="url(#myMask)"></rect>`
          }
        },
    },
    {
        name: 'Borderless No Text',
        id: 'borderlessportrait',
        value: 'borderlessportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '50%',
                y: '80%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
              {
                x: '50%',
                y: '83%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
              {
                x: '50%',
                y: '86%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
            ]
          }
        },
    },
    {
        name: 'Border No Text',
        id: 'borderportrait',
        value: 'borderportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.969844,-1.35398,1.63528)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '92.5%',
                y: '90%',
                textanchor: 'end',
                fontsize: '0.95em',
                fontfamily: 'Futura',
                extrastyle: `display: none;`
              },
              {
                x: '92.5%',
                y: '92%',
                textanchor: 'end',
                fontsize: '0.65em',
                fontfamily: 'Futura Light',
                extrastyle: `display: none;`
              },
              {
                x: '92.5%',
                y: '94%',
                textanchor: 'end',
                fontsize: '0.65em',
                fontfamily: 'Futura Light',
                extrastyle: `display: none;`
              },
            ],
            intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <rect width="85%" height="85%" x="7.5%" y="7.5%"></rect>
              </mask>
            `,
            overlay: `<rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" mask="url(#myMask)"></rect>`
          }
        },
    },
    {
        name: 'Overlay',
        id: 'overlayportrait',
        value: 'overlayportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {//viewBox="${svgViewBox}"
          text: {
            pos: [
              {
                x: '50%',
                y: '25%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
              {
                x: '50%',
                y: '50%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
              {
                x: '50%',
                y: '75%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
            ],
          }
        },
    },
    //Landscape
    {
        name: 'Classic',
        id: 'classiclandscape',
        value: 'classiclandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,53.8766)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,51.3019)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3295)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '95%',
                y: '88.5%',
                textanchor: 'end',
                fontsize: '0.3em',
                fontfamily: 'Futura',
                extrastyle: `text-transform: uppercase; alignment-baseline: after-edge;`
              },
              {
                x: '95%',
                y: '91.5%',
                textanchor: 'end',
                fontsize: '0.18em',
                fontfamily: 'Futura Light',
                extrastyle: `alignment-baseline: after-edge;`
              },
              {
                x: '95%',
                y: '95%',
                textanchor: 'end',
                fontsize: '0.18em',
                fontfamily: 'Futura Light',
                extrastyle: `alignment-baseline: after-edge;`
              },
            ],
            intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <rect width="90%" height="72%" x="5%" y="5%"></rect>
              </mask>
            `,
            overlay: `<rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" mask="url(#myMask)"></rect>`
          }
        },
    },
    {
        name: 'Modern',
        id: 'modernlandscape',
        value: 'modernlandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <use xlink:href="#_Image1" x="19.238" y="59.128" width="61.707px" height="34.312px" transform="matrix(0.995271,0,0,0.98035,0,0)"/> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,37.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,40.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,43.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <defs> <image id="_Image1" width="62px" height="35px" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAjCAYAAADMibkBAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWUlEQVRoge3TwQnAMAwEQQUCdv8NJ2XoMTsVePHpmZlvQO85Z/sNKwrXvPfe7TescH+8cEw3rnHDmzqmcE03rnHDmzrGDW/qmMI13bimcE03rnHDmzqGDf8BaHQEbhvmzbcAAAAASUVORK5CYII="/> </defs> </svg>`,
        layout: {//viewBox="${svgViewBox}"
          text: {
            pos: [
              {
                x: '50%',
                y: '80%',
                textanchor: 'middle',
                fontsize: '0.36em',
                fontfamily: 'Futura',
                extrastyle: `text-transform: uppercase;`
              },
              {
                x: '50%',
                y: '85%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light'
              },
              {
                x: '50%',
                y: '90%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura Light'
              },
            ],
            intro: `
              <defs>
                <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="82%">
                  <stop offset="50%" style="stop-color:rgb(255, 255, 255);stop-opacity:0"></stop>
                  <stop offset="100%" style="stop-color:rgb(255, 255, 255);stop-opacity:1"></stop>
                </linearGradient>
              </defs>
            `,
            overlay: `<rect width="100%" height="100%" fill="url(#grad2)"></rect>`
          }
        },
    },
    {
        name: 'Circular',
        id: 'circularlandscape',
        value: 'circularlandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,45.6831)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,48.8931)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,51.9776)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,-1.64129)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '90%',
                y: '83.5%',
                textanchor: 'end',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: `alignment-baseline: after-edge; text-transform: uppercase;`
              },
              {
                x: '90%',
                y: '86.5%',
                textanchor: 'end',
                fontsize: '0.16em',
                fontfamily: 'Futura Light',
                extrastyle: `alignment-baseline: after-edge;`
              },
              {
                x: '90%',
                y: '90%',
                textanchor: 'end',
                fontsize: '0.16em',
                fontfamily: 'Futura Light',
                extrastyle: `alignment-baseline: after-edge;`
              },
            ],
            intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <circle cx="50%" cy="50%" r="30%"/>
              </mask>
            `,
            overlay: `<rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" mask="url(#myMask)"></rect>`
          }
        },
    },
    {
        name: 'Borderless No Text',
        id: 'borderlesslandscape',
        value: 'borderlesslandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '50%',
                y: '80%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
              {
                x: '50%',
                y: '83%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
              {
                x: '50%',
                y: '86%',
                textanchor: 'middle',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: 'display: none;'
              },
            ]
          }
        },
    },
    {
        name: 'Border No Text',
        id: 'borderlandscape',
        value: 'borderlandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.969844,-1.35398,1.63528)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {
          text: {
            pos: [
              {
                x: '92.5%',
                y: '90%',
                textanchor: 'end',
                fontsize: '0.2em',
                fontfamily: 'Futura',
                extrastyle: `display: none;`
              },
              {
                x: '92.5%',
                y: '92%',
                textanchor: 'end',
                fontsize: '0.12em',
                fontfamily: 'Futura Light',
                extrastyle: `display: none;`
              },
              {
                x: '92.5%',
                y: '94%',
                textanchor: 'end',
                fontsize: '0.12em',
                fontfamily: 'Futura Light',
                extrastyle: `display: none;`
              },
            ],
            intro: `
              <mask id="myMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF"></rect>
                  <rect width="90%" height="90%" x="5%" y="5%"></rect>
              </mask>
            `,
            overlay: `<rect x="0" y="0" width="100%" height="100%" fill="#FFFFFF" mask="url(#myMask)"></rect>`
          }
        },
    },
    {
        name: 'Overlay',
        id: 'overlaylandscape',
        value: 'overlaylandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
        layout: {//viewBox="${svgViewBox}"
          text: {
            pos: [
              {
                x: '50%',
                y: '25%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
              {
                x: '50%',
                y: '50%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
              {
                x: '50%',
                y: '75%',
                textanchor: 'middle',
                fontsize: '0.74em',
                fontfamily: 'Futura',
                extrastyle: 'alignment-baseline: middle; text-transform: uppercase; -webkit-filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255)); filter: drop-shadow( 0.09em 0.09em 0px rgb(255, 255, 255));'
              },
            ],
          }
        },
    },
];